document.addEventListener('DOMContentLoaded', () => {
                         
  if(document.body.classList.contains('template-collection')) {
  const form = document.querySelectorAll('form[action="/cart/add"]')
  
  
  
  function updateCart() {
    const cartQuantity = document.querySelector('a[href="/cart"] .cartCost')
    fetch('/cart.js', {
          credentials: 'same-origin',
          headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'xmlhttprequest'
        },
        method: 'GET'
      }).then(function(response) {
          return response.json();

        }).then(function(json) {
          cartQuantity.innerHTML = `(${json.item_count})`
        })
  }
	
    form.forEach((currentForm) => {
      const plus = currentForm.querySelector('.dev-qty-plus')
      const minus = currentForm.querySelector('.dev-qty-minus')
      const addMessage = currentForm.querySelector('.addPopup')
      
      function addMessageShow(message) {
          addMessage.innerHTML = message
          addMessage.classList.add('added')
          window.setTimeout(()=> {
          	addMessage.classList.remove('added')   
          	
          }, 3000)        
        }
      
        plus.onclick = function() {
        	event.preventDefault()
            plus.previousElementSibling.value++
           	
        }
        minus.onclick = function() {
        	event.preventDefault()
            if( minus.nextElementSibling.value != 1 ) {
            	minus.nextElementSibling.value--
            }
            
        }
      currentForm.addEventListener('submit', (e) => {
        const variant = currentForm.querySelector('select')
        const quantity = currentForm.querySelector('input').value
        
        
        e.preventDefault()
        
        let addData = {
          'id':'',
          'quantity':''
        };
        // set data
        addData.id = variant.options[variant.selectedIndex].value
        addData.quantity = quantity
		// add to cart
        fetch('/cart/add.js', {
          body: JSON.stringify(addData),
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With':'xmlhttprequest'
          },
          method: 'POST'
        }).then(function(response) {
          	return response.json();
        }).then(function(json) {
          if(json.status) {
            addMessageShow(json.description)
          } else {
         // sucesfull added
          	addMessageShow('Added to cart')
         	updateCart()
         }
          
          
        });
      })
    })
  }
})